import React from 'react';
import ListView from './ListView';

export default function SubListView({ events, title, onEventClick, onBack, likedIds, onToggleLike }) {
  return (
    <div className="sub-list-view">
      <div className="sub-list-header">
        <button className="btn-back" onClick={onBack}>← Back</button>
        <h2 className="sub-list-title">{title}</h2>
        <span className="sub-list-count">{events.length} event{events.length !== 1 ? 's' : ''}</span>
      </div>
      <ListView
        opportunities={events}
        onEventClick={onEventClick}
        likedIds={likedIds}
        onToggleLike={onToggleLike}
      />
    </div>
  );
}
